var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptions = function SvgOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    fillRule: "evenodd",
    d: "m6.398 14.765.496 1.118a1.88 1.88 0 0 0 3.438 0l.497-1.118a2.06 2.06 0 0 1 2.1-1.21l1.215.13a1.88 1.88 0 0 0 1.719-2.977l-.72-.989a2.06 2.06 0 0 1-.39-1.219c0-.436.137-.862.394-1.215l.72-.988a1.88 1.88 0 0 0-1.72-2.977l-1.215.13a2.07 2.07 0 0 1-1.25-.266 2.06 2.06 0 0 1-.85-.95l-.5-1.117a1.88 1.88 0 0 0-3.438 0l-.496 1.118c-.176.398-.474.73-.85.949a2.07 2.07 0 0 1-1.25.265l-1.22-.13A1.88 1.88 0 0 0 1.36 6.298l.72.988a2.065 2.065 0 0 1 0 2.43l-.72.988a1.88 1.88 0 0 0 1.719 2.977l1.215-.13a2.07 2.07 0 0 1 2.104 1.215m2.215-3.726a2.539 2.539 0 1 0 0-5.078 2.539 2.539 0 0 0 0 5.078",
    clipRule: "evenodd"
  })));
};
export default SvgOptions;